import type { IconProps } from './types';

export function Maio({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M92 36 Q98 58 104 80 Q116 76 128 76 Q140 76 152 80 Q158 58 164 36 Q168 38 172 40 Q166 62 160 84 Q172 90 184 96 Q184 142 184 188 Q176 188 168 188 Q150 206 132 224 Q128 226 124 224 Q106 206 88 188 Q80 188 72 188 Q72 142 72 96 Q84 90 96 84 Q90 62 84 40 Q88 38 92 36 Z" />
    </svg>
  );
}
